/*
XXX_JSREFACTOR_XXX
todo @JSREFACTOR
    - write tests for this and refactor if needed
*/
import { GoogleTagManagerDeprecated } from 'root/utils/tracking/googleTagManagerDeprecated';

(function () {
    const el = document.querySelector('[data-careers]');
    if (el) {
        const filterListener = () => {
            el.querySelector('[data-careers="filter-button"]')?.addEventListener(
                'click',
                () => {
                    window.location = el.querySelector(
                        '[data-careers="filter-select"]'
                    )?.value;
                }
            );
        };
        const gtmListeners = () => {
            const hero = el.querySelector('[data-careers="hero"]');
            const reviews = el.querySelector('[data-careers="reviews"]');
            hero &&
                sendEventToGoogle(
                    hero,
                    '[data-careers="video-button"]',
                    'Video Hero Click'
                );
            reviews &&
                sendEventToGoogle(
                    reviews,
                    '[data-careers="glassdoor-link"]',
                    'Glassdoor Link'
                );
        };

        // @todo: replace this with an existing `utils` function
        const sendEventToGoogle = (container, target, eventAction = 'default') => {
            if (container) {
                const targetElement = container.querySelector(target);

                if (targetElement) {
                    targetElement.addEventListener('click', () => {
                        const gtm = new GoogleTagManagerDeprecated();
                        gtm.sendEvent('GAEvent', 'Careers CTA', eventAction, '');
                    });
                }
            }
        };

        const getCareersListItems = mobileSecondaryNav => {
            return Array.from(
                mobileSecondaryNav?.querySelectorAll(
                    '[data-navigation-platform="mobile"][data-navigation-level="child"]'
                )
            )?.filter(
                item =>
                    window.getComputedStyle(item).getPropertyValue('display') !== 'none'
            );
        };

        const getOpeningButton = openingsListItem => {
            const openingsButtonElement = document.createElement('a');
            openingsButtonElement.classList.add('js-openings-button');
            const openingsListItemAnchorTag = openingsListItem.firstElementChild;

            if (openingsListItemAnchorTag && openingsListItemAnchorTag.tagName === 'A') {
                openingsButtonElement.href = openingsListItemAnchorTag.href;
                openingsButtonElement.innerText =
                    openingsListItemAnchorTag.innerText.trim();
                return openingsButtonElement;
            }
        };

        const displayOpeningsOnMobile = () => {
            const mobileNav = document.querySelector(
                '[data-navigation-type="btf-mobile"]'
            );
            if (
                mobileNav &&
                (window.getComputedStyle(mobileNav).getPropertyValue('display') !==
                    'none' ||
                    window.getComputedStyle(mobileNav).getPropertyValue('visibility') !==
                        'hidden')
            ) {
                const mobileSecondaryNavHeader = mobileNav.querySelector(
                    '[data-secondary-nav-header]'
                );
                if (mobileSecondaryNavHeader) {
                    mobileSecondaryNavHeader.style.position = 'relative';
                    const careersListItems = getCareersListItems(
                        mobileSecondaryNavHeader
                    );
                    const getOpeningsListItem =
                        careersListItems.length > 0 &&
                        careersListItems[careersListItems.length - 1];
                    if (
                        typeof getOpeningButton(getOpeningsListItem) !== 'undefined' &&
                        !getOpeningsListItem.classList.contains(
                            'navigation-btf-mobile__item--active'
                        )
                    ) {
                        mobileSecondaryNavHeader.insertBefore(
                            getOpeningButton(getOpeningsListItem),
                            mobileSecondaryNavHeader.firstChild
                        );
                        careersListItems[careersListItems.length - 1].remove();
                    }
                }
            }
        };

        const init = () => {
            gtmListeners();
            filterListener();
            displayOpeningsOnMobile();
        };

        return {
            init,
        };
    }
})()?.init();
